import { IServerError } from 'types'

export const isServerError = (obj: unknown): obj is IServerError =>
  !!obj
  && obj != null
  && typeof (obj as IServerError).status === 'string'
  && typeof (obj as IServerError).message === 'string'

export default isServerError
